var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.enableBell())?_c('van-button',{attrs:{"size":"large","icon":"service-o"},on:{"click":_vm.cmdServiceType}},[_vm._v(" 服務鈴 "+_vm._s(_vm.$route.query.tblid)+" ")]):_vm._e(),_c('ServiceType',{ref:"rServiceType"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }